(function () {
  const FREE_VARIANT_ID = 54323800637806;

  let syncing = false;
  let syncTimer = null;

  /*
   * ---------------------------------------------------------
   * GET CART
   * ---------------------------------------------------------
   */
  async function getCart() {
    const response = await fetch('/cart.js', {
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Unable to get cart');
    }

    return response.json();
  }

  /*
   * ---------------------------------------------------------
   * GET CART SECTIONS
   * ---------------------------------------------------------
   */
  function getCartSections() {
    const sections = [];

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      cartDrawer.getSectionsToRender().forEach((section) => {
        const id = section.section || section.id;
        if (id && !sections.includes(id)) {
          sections.push(id);
        }
      });
    }

    const mainCartItems = document.querySelector('cart-items');
    if (mainCartItems && typeof mainCartItems.getSectionsToRender === 'function') {
      mainCartItems.getSectionsToRender().forEach((section) => {
        const id = section.section || section.id;
        if (id && !sections.includes(id)) {
          sections.push(id);
        }
      });
    }

    if (sections.length === 0) {
      sections.push('cart-drawer', 'cart-icon-bubble', 'cart-live-region-text');
    }

    return sections;
  }

  /*
   * ---------------------------------------------------------
   * UPDATE FREE GIFT QUANTITY PILLS
   * ---------------------------------------------------------
   */
  function updateFreePills(totalQuantity) {
    const qty = totalQuantity > 0 ? totalQuantity : 1;
    document.querySelectorAll('.cart-item__free-qty-pill').forEach((pill) => {
      pill.textContent = qty;
    });
  }

  /*
   * ---------------------------------------------------------
   * RENDER CART
   * ---------------------------------------------------------
   */
  function renderCart(response) {
    if (!response || !response.sections) {
      return;
    }

    const isEmpty = response.item_count === 0;

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.classList.toggle('is-empty', isEmpty);
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      if (drawerInner) {
        drawerInner.classList.toggle('is-empty', isEmpty);
      }
      if (typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents(response);
      }
    }

    const cartFooter = document.getElementById('main-cart-footer');
    if (cartFooter) {
      cartFooter.classList.toggle('is-empty', isEmpty);
    }

    const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
    if (cartItems) {
      cartItems.classList.toggle('is-empty', isEmpty);
      if (typeof cartItems.getSectionsToRender === 'function') {
        cartItems.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace && response.sections[section.section]) {
            const parsed = new DOMParser().parseFromString(response.sections[section.section], 'text/html');
            const sourceEl = parsed.querySelector(section.selector) || parsed.getElementById(section.id);
            if (sourceEl) {
              elementToReplace.innerHTML = sourceEl.innerHTML;
            }
          }
        });
      }
    }

    // Refresh bubble
    if (response.sections['cart-icon-bubble']) {
      const bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        bubble.innerHTML =
          new DOMParser()
            .parseFromString(response.sections['cart-icon-bubble'], 'text/html')
            .getElementById('cart-icon-bubble')?.innerHTML || response.sections['cart-icon-bubble'];
      }
    }

    // Hide any active spinners
    document.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
  }

  /*
   * ---------------------------------------------------------
   * SYNC FREE GIFT
   * ---------------------------------------------------------
   */
  async function syncFreeGift() {
    if (syncing) {
      return;
    }

    syncing = true;

    try {
      const cart = await getCart();

      const giftLines = cart.items.filter(
        (item) => Number(item.variant_id) === FREE_VARIANT_ID || Number(item.id) === FREE_VARIANT_ID
      );

      const normalLines = cart.items.filter(
        (item) => Number(item.variant_id) !== FREE_VARIANT_ID && Number(item.id) !== FREE_VARIANT_ID
      );

      const totalNormalQuantity = normalLines.reduce(
        (total, item) => total + Number(item.quantity),
        0
      );

      const currentGiftQuantity = giftLines.reduce(
        (total, item) => total + Number(item.quantity),
        0
      );

      updateFreePills(totalNormalQuantity);

      const sections = getCartSections();

      if (totalNormalQuantity > 0) {
        // Sync actual cart free gift quantity to match totalNormalQuantity for checkout
        if (currentGiftQuantity !== totalNormalQuantity || giftLines.length > 1) {
          if (currentGiftQuantity === 0) {
            // Add free gift with totalNormalQuantity
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: FREE_VARIANT_ID,
                    quantity: totalNormalQuantity
                  }
                ],
                sections: sections,
                sections_url: window.location.pathname
              })
            });

            const data = await response.json();
            if (response.ok) {
              renderCart(data);
            }
          } else {
            // Update existing gift quantity to match totalNormalQuantity
            const response = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                updates: {
                  [FREE_VARIANT_ID]: totalNormalQuantity
                },
                sections: sections,
                sections_url: window.location.pathname
              })
            });

            const data = await response.json();
            if (response.ok) {
              renderCart(data);
            }
          }
        }
      } else {
        // Cart has no normal products, remove free gift if present
        if (currentGiftQuantity > 0) {
          const response = await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              updates: {
                [FREE_VARIANT_ID]: 0
              },
              sections: sections,
              sections_url: window.location.pathname
            })
          });

          const data = await response.json();
          if (response.ok) {
            renderCart(data);
          }
        }
      }
    } catch (error) {
      console.error('[Free Gift]', error);
    } finally {
      syncing = false;
    }
  }

  /*
   * ---------------------------------------------------------
   * DELAYED SYNC
   * ---------------------------------------------------------
   */
  function scheduleSync(delay = 150) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncFreeGift, delay);
  }

  /*
   * ---------------------------------------------------------
   * INIT
   * ---------------------------------------------------------
   */
  function init() {
    if (
      typeof subscribe === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined' &&
      PUB_SUB_EVENTS.cartUpdate
    ) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.source === 'auto-gift') {
          return;
        }
        scheduleSync(150);
      });
    }

    // Initial check on load
    scheduleSync(300);
  }

  /*
   * ---------------------------------------------------------
   * START
   * ---------------------------------------------------------
   */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /*
   * Public API
   */
  window.FreeGift = {
    sync: syncFreeGift,
    FREE_VARIANT_ID: FREE_VARIANT_ID
  };
})();